var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQAiPauseButton = function SvgQAiPauseButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CCDE",
    fillRule: "evenodd",
    d: "M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 9.608,
    x: 12.491,
    y: 11.195,
    fill: "#fff",
    rx: 0.938
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.875,
    height: 9.608,
    x: 18.041,
    y: 11.195,
    fill: "#fff",
    rx: 0.938
  })));
};
export { SvgQAiPauseButton as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMiAxNkMzMiAyNC44MzY2IDI0LjgzNjYgMzIgMTYgMzJDNy4xNjM0MyAzMiAwIDI0LjgzNjYgMCAxNkMwIDcuMTYzNDMgNy4xNjM0MyAwIDE2IDBDMjQuODM2NiAwIDMyIDcuMTYzNDMgMzIgMTZaIiBmaWxsPSIjQzlDQ0RFIi8+CjxyZWN0IHg9IjEyLjQ5MDUiIHk9IjExLjE5NTMiIHdpZHRoPSIxLjg3NTM3IiBoZWlnaHQ9IjkuNjA3OTEiIHJ4PSIwLjkzNzY4MyIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTguMDQxNSIgeT0iMTEuMTk1MyIgd2lkdGg9IjEuODc1IiBoZWlnaHQ9IjkuNjA3OTEiIHJ4PSIwLjkzNzUiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";